import { render, staticRenderFns } from "./documentLookupFields.vue?vue&type=template&id=4174c69e&scoped=true&"
import script from "./documentLookupFields.vue?vue&type=script&lang=ts&"
export * from "./documentLookupFields.vue?vue&type=script&lang=ts&"
import style0 from "./documentLookupFields.vue?vue&type=style&index=0&id=4174c69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4174c69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4174c69e', component.options)
    } else {
      api.reload('4174c69e', component.options)
    }
    module.hot.accept("./documentLookupFields.vue?vue&type=template&id=4174c69e&scoped=true&", function () {
      api.rerender('4174c69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documentLookupFields.vue"
export default component.exports